var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loader-wrapper',[_c('div',{staticClass:"stub__content"},[_c('div',{staticClass:"stub__content_icon pulse"},[_vm._t("icon")],2),_vm._t("title")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }